var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskLevelArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 20,
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95478 0.863001L0.0814089 15.157C-0.421807 17.6594 1.47167 20 4.00013 20C6.52771 20 8.42118 17.6602 7.91885 15.157L5.04547 0.863001C4.81377 -0.287667 3.18561 -0.287667 2.95478 0.863001Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLevelArrow);
export default __webpack_public_path__ + "static/media/risk-level-arrow.4c884a0ccec267022860946bd01929f5.svg";
export { ForwardRef as ReactComponent };